/* ==========================================================================
   Kuba · Acessórios — comportamento da seção "Kuba PDP · Acessório"
   (galeria com miniaturas, variantes, "Frequentemente comprados juntos",
   barra de frete grátis, CTA dinâmico e "Avise-me").
   Vanilla JS, idempotente (o editor de temas recarrega seções).
   A compra usa o form nativo do Ecomus (<wrapp-hdt-pr-frm> + .hdt-main-product-form):
   este script só monta os inputs items[i][id]/[quantity] — quem envia é o tema
   (abre o cart drawer, compatível com o checkout Yampi).
   ========================================================================== */
(function () {
  'use strict';
  if (window.__kbaLoaded) { window.__kbaInit && window.__kbaInit(); return; }
  window.__kbaLoaded = true;

  function brl(cents, short) {
    var v = (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (short) v = v.replace(',00', '');
    return 'R$ ' + v;
  }
  function tpl(str, map) {
    return (str || '').replace(/\[(\w+)\]/g, function (m, k) { return k in map ? map[k] : m; });
  }

  /* --- galeria com miniaturas --- */
  function gallery(sec) {
    var g = sec.querySelector('[data-kba-gallery]');
    if (!g || g.__kba) return;
    g.__kba = true;
    var track = g.querySelector('[data-kba-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var thumbs = g.querySelectorAll('[data-kba-thumb]');
    var i = 0;
    function go(n) {
      if (!slides.length) return;
      i = ((n % slides.length) + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      var t = thumbs[i];
      if (t && t.scrollIntoView) { try { t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); } catch (e) {} }
    }
    g.__go = go;
    var prev = g.querySelector('[data-kba-prev]'), next = g.querySelector('[data-kba-next]');
    prev && prev.addEventListener('click', function () { go(i - 1); });
    next && next.addEventListener('click', function () { go(i + 1); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var x0 = null;
    g.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    g.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
    }, { passive: true });
  }

  /* --- estado da seção --- */
  function setup(sec) {
    if (sec.__kba) return;
    sec.__kba = true;
    gallery(sec);

    var cfg = {};
    try { cfg = JSON.parse(sec.getAttribute('data-kba-config') || '{}'); } catch (e) { cfg = {}; }
    var threshold = parseInt(cfg.threshold, 10) || 0;          // centavos; 0 = sem barra
    var bundleOn = !!cfg.bundle;

    var radios = sec.querySelectorAll('[data-kba-variant]');
    var idInput = sec.querySelector('[data-kba-variant-id]');
        var priceNow = sec.querySelector('[data-kba-price-now]');
    var priceWas = sec.querySelector('[data-kba-price-was]');
    var mainPrice = sec.querySelector('[data-kba-main-price]');
    var inst = sec.querySelector('[data-kba-installments]');
    var buy = sec.querySelector('[data-kba-buy]');
    var buyLabel = sec.querySelector('[data-kba-buy-label]');
    var soldBoxes = sec.querySelectorAll('[data-kba-soldout]');
    var soldName = sec.querySelectorAll('[data-kba-variant-name]');
    var notifyVariant = sec.querySelector('[data-kba-notify-variant]');
    var notifyProduct = sec.querySelector('[data-kba-notify-product]');
    var onlyLink = sec.querySelector('[data-kba-only]');
    var onlyLabel = sec.querySelector('[data-kba-only-label]');
    var checks = sec.querySelectorAll('[data-kba-check]');
    var countEl = sec.querySelector('[data-kba-count]');
    var totalEl = sec.querySelector('[data-kba-total]');
    var shipNote = sec.querySelector('[data-kba-ship-note]');
    var shipBar = sec.querySelector('[data-kba-ship-bar]');
    var form = sec.querySelector('form.hdt-main-product-form');

    function current() {
      var r = null;
      radios.forEach(function (x) { if (x.checked) r = x; });
      if (r) return { id: r.value, price: parseInt(r.dataset.price, 10) || 0, compare: parseInt(r.dataset.compare, 10) || 0, available: r.dataset.available === 'true', name: r.dataset.name || '', img: parseInt(r.dataset.img, 10) };
      return { id: cfg.variantId, price: parseInt(cfg.price, 10) || 0, compare: parseInt(cfg.compare, 10) || 0, available: cfg.available !== false, name: cfg.variantName || '' };
    }

    function extras() {
      var out = [];
      checks.forEach(function (c) { if (c.checked && !c.disabled) out.push({ id: c.value, price: parseInt(c.dataset.price, 10) || 0 }); });
      return out;
    }

    /* pré-marca: blocos "sempre" + (opcional) o item mais barato que destrava o frete */
    function precheck() {
      if (!bundleOn || !checks.length) return;
      var v = current();
      var any = false;
      checks.forEach(function (c) { if (c.dataset.pre === 'true') { c.checked = true; any = true; } });
      if (cfg.autoPre && threshold > 0 && v.price < threshold) {
        var best = null;
        checks.forEach(function (c) {
          if (c.disabled) return;
          var p = parseInt(c.dataset.price, 10) || 0;
          if (v.price + p >= threshold && (!best || p < (parseInt(best.dataset.price, 10) || 0))) best = c;
        });
        if (best) { best.checked = true; any = true; }
      }
      return any;
    }

    function render() {
      var v = current();
      var ex = extras();
      var total = v.price + ex.reduce(function (s, e) { return s + e.price; }, 0);
      var n = 1 + ex.length;
      var free = threshold > 0 && total >= threshold;
      var gap = threshold - total;

      // preço / parcela
      if (priceNow) priceNow.textContent = brl(v.price, true);
      if (mainPrice) mainPrice.textContent = brl(v.price);
      if (priceWas) { if (v.compare > v.price) { priceWas.textContent = brl(v.compare, true); priceWas.hidden = false; } else { priceWas.hidden = true; } }
      if (inst) {
        var nParc = parseInt(cfg.installments, 10) || 6;
        var minParc = parseInt(cfg.minInstallment, 10) || 0;
        var k = nParc;
        if (minParc > 0) k = Math.max(1, Math.min(nParc, Math.floor(v.price / minParc)));
        inst.textContent = k > 1 ? tpl(cfg.instText, { n: k, parcela: brl(Math.round(v.price / k)) }) : (cfg.instOne || '');
      }
      soldName.forEach(function (el) { el.textContent = v.name; });
      if (notifyVariant) notifyVariant.value = v.name;
      if (notifyProduct) notifyProduct.value = (cfg.productTitle || '') + (v.name ? ' (' + v.name + ')' : '') + ' — ' + (cfg.productUrl || '') + (v.id ? '?variant=' + v.id : '');

      // itens do form: principal + extras marcados (pares items[][id]/[quantity])
      if (idInput) idInput.value = v.id || '';
      checks.forEach(function (c) {
        var row = c.closest('[data-kba-row]');
        if (!row) return;
        row.querySelectorAll('input[type="hidden"]').forEach(function (h) { h.disabled = !(c.checked && !c.disabled); });
      });

      // CTA
      if (buy) { buy.disabled = !v.available; buy.hidden = !v.available; }
      if (buyLabel) {
        var map = { n: n, total: brl(total, true), preco: brl(v.price, true), titulo: cfg.productTitle || '', variante: v.name };
        var label = ex.length ? tpl(cfg.ctaMulti, map) : tpl(cfg.ctaSingle, map);
        if (ex.length && free && cfg.ctaFree) label += cfg.ctaFree;
        buyLabel.textContent = label;
      }
      soldBoxes.forEach(function (el) { el.hidden = v.available; });
      sec.querySelectorAll('[data-kba-avail]').forEach(function (el) { el.hidden = !v.available; });
      if (onlyLink) {
        onlyLink.hidden = !(ex.length && v.available);
        if (onlyLabel) onlyLabel.textContent = tpl(cfg.onlyText, { preco: brl(v.price, true), titulo: cfg.productTitle || '', variante: v.name });
      }

      // bloco "comprados juntos"
      if (countEl) countEl.textContent = n + (n === 1 ? ' item' : ' itens');
      if (totalEl) totalEl.textContent = brl(total);
      if (shipNote) {
        shipNote.textContent = free ? (cfg.shipFree || '') : tpl(cfg.shipGap, { falta: brl(gap, true) });
        shipNote.classList.toggle('is-free', free);
      }
      if (shipBar) {
        var pct = threshold > 0 ? Math.min(100, Math.round((total / threshold) * 100)) : 0;
        shipBar.style.width = pct + '%';
        shipBar.classList.toggle('is-free', free);
      }
      checks.forEach(function (c) { var row = c.closest('[data-kba-row]'); if (row) row.classList.toggle('is-off', !c.checked); });
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        var g = sec.querySelector('[data-kba-gallery]');
        var img = parseInt(r.dataset.img, 10);
        if (g && g.__go && !isNaN(img) && img >= 0) g.__go(img);
        render();
      });
    });
    checks.forEach(function (c) { c.addEventListener('change', render); });

    // "ou comprar só o X": desmarca os extras e envia o form do tema
    if (onlyLink && form) {
      onlyLink.addEventListener('click', function (e) {
        e.preventDefault();
        checks.forEach(function (c) { c.checked = false; });
        render();
        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.click(); else if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    }

    // "Avise-me": só marca visualmente o envio (o form 'contact' é do Shopify)
    var notify = sec.querySelector('[data-kba-notify] form');
    if (notify) {
      notify.addEventListener('submit', function () {
        var b = notify.querySelector('[type="submit"]');
        if (b) { b.disabled = true; b.textContent = b.dataset.sending || 'Enviando…'; }
      });
    }

    precheck();
    render();
  }

  function init() {
    document.querySelectorAll('[data-kba]').forEach(setup);
  }
  window.__kbaInit = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });
})();
